import StarIcon from "@mui/icons-material/Star.js";
import StarBorderIcon from "@mui/icons-material/StarBorder.js";
import CheckBoxIcon from "@mui/icons-material/CheckBox.js";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank.js";
import TaskAltIcon from "@mui/icons-material/TaskAlt.js";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked.js";

const CHECK_DISPLAYS = {
  star: {
    done: StarIcon,
    none: StarBorderIcon,
  },
  check: {
    done: CheckBoxIcon,
    none: CheckBoxOutlineBlankIcon,
  },
  rounded_check: {
    done: TaskAltIcon,
    none: RadioButtonUncheckedIcon,
  },
};

export default CHECK_DISPLAYS;
